import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from 'components/styled/Text';
import { colors } from '../../constants';

const ValidationMessageContainer = styled.div`
  background: ${colors.orange};
  height: 20px;
  position: absolute;
  left: -1px;
  bottom: -20px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 2px 7px 2px 4px;
  z-index: 1;
`;

const ValidationMessage = ({ text }) => {
  return (
    <ValidationMessageContainer>
      <Text color={colors.white} variant="caption">
        {text}
      </Text>
    </ValidationMessageContainer>
  );
};

ValidationMessage.propTypes = {
  text: PropTypes.string.isRequired,
};

export default ValidationMessage;
